import {useLocation} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {calcFilterData} from "../../utils/common/calcFilterData";
import {EditLocalStoragePagesData} from "../../utils/EditLocalStoragePagesData";

export const withFilter = (Component, filterDataArr) => {
    return (props) => {
        const pathname = useLocation().pathname
        const [filteredData, setFilteredData] = useState([])
        const [globalFilter, setGlobalFilter] = useState('');
        const [columnsFilter, setColumnsFilter] = useState([]);

        const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
            const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
            const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

            const data = Array.isArray(prevData) ? [...prevData] : []
            const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, filterDataArr) : data
            const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
                return calcFilterData(accumulator, currentValue?.value, [filterDataArr.find(el => el.idFromColumnFilter === currentValue.id || el.id === currentValue.id)])
            }, globalFilterData);

            setFilteredData(newData)

            props.tableOptionsHandle({
                ...props.tableOptions,
                totalElements: newData.length,
                pageSize: pageSize ? pageSize : props.tableOptions?.pageSize
            })

            if (isColumnFilters) {
                setColumnsFilter(searchQuery)
            } else {
                setGlobalFilter(searchQuery || "")
                if (searchQuery !== globalFilter) {
                    EditLocalStoragePagesData(`${pathname}-${props.type}`, "searchQuery", searchQuery)
                }
            }
        }
        useEffect(() => {
            const {searchQuery, pageSize} = getStartPageSize()
            handleSearchQuery(searchQuery, props.data, pageSize)
        }, [props.data])

        const getStartPageSize = () => {
            const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
            const pageSize = pagesData[`${pathname}-${props.type}`]?.pageSize
            const searchQuery = pagesData[`${pathname}-${props.type}`]?.searchQuery

            return {searchQuery, pageSize}
        }
        return <Component
            {...props}
            globalFilter={globalFilter}
            handleSearchQuery={handleSearchQuery}
            filteredData={filteredData}
            columnsFilter={columnsFilter}
        />;
    };
};
